import {
  API_OFFERING_ORDER_URL,
  API_OFFERING_ORDER_URL_W_PARAMS,
  replacePlaceholders,
} from './urls';
import callWebApi from './callWebApi';
import { createFetchActionCreator } from './index';


export const PLACE_ORDER = 'PLACE_ORDER';
export const PLACE_ORDER_SUCCESSFUL = 'PLACE_ORDER_SUCCESSFUL';
export const PLACE_ORDER_FAILURE = 'PLACE_ORDER_FAILURE';
export const ORDER_CANCELED = 'ORDER_CANCELED';

export const placeOrder = offerId => async (dispatch, getState) => {
  const state = getState();
  const {
    authToken,
    currentAccount,
    offerOrderForm,
  } = state;
  const { requestedDollarAmount } = offerOrderForm.offerOrderAmount;
  const PLACE_ORDER_URL = API_OFFERING_ORDER_URL.replace('{accountNumber}', currentAccount);

  dispatch({ type: PLACE_ORDER, offerId });

  let res;
  try {
    // hit API with the investment request
    res = await callWebApi(
      'POST', PLACE_ORDER_URL, {
        accountNumber: currentAccount,
        offerId,
        requestedTotalCurrencyAmt: requestedDollarAmount,
      },
      authToken,
    );
  } catch (err) {
    dispatch({
      type: PLACE_ORDER_FAILURE,
      error: err,
      offerId,
    });
    return { err };
  }

  dispatch({
    type: PLACE_ORDER_SUCCESSFUL,
    offerId,
    confirmationId: res.offerOrderId,
  });
  return { res };
};

export const placeExternalOrder = offerId => async (dispatch, getState) => {
  const state = getState();
  const {
    authToken,
    currentAccount,
    externalOfferOrderForm,
  } = state;
  const { requestedDollarAmount } = externalOfferOrderForm.externalOfferOrderAmount;
  const PLACE_ORDER_URL = API_OFFERING_ORDER_URL.replace('{accountNumber}', currentAccount);
  const deliverSecuritiesMode = externalOfferOrderForm.externalOfferOrderDelivery.delivery;
  const acc = externalOfferOrderForm.externalOfferOrderAmount.accreditation;

  dispatch({ type: PLACE_ORDER, offerId });

  let res;
  try {
    // hit API with the investment request
    res = await callWebApi(
      'POST', PLACE_ORDER_URL, {
        accountNumber: currentAccount,
        offerId,
        requestedTotalCurrencyAmt: requestedDollarAmount,
        deliverSecuritiesMode,
        accreditation: acc,
      },
      authToken,
    );
  } catch (err) {
    dispatch({
      type: PLACE_ORDER_FAILURE,
      error: err,
      offerId,
    });
    return { err };
  }

  dispatch({
    type: PLACE_ORDER_SUCCESSFUL,
    offerId,
    confirmationId: res.offerOrderId,
  });
  return { res };
};


export const fetchOfferingOrders = accountNumber => (dispatch, getState) => {
  const actionCreator = createFetchActionCreator(
    replacePlaceholders(API_OFFERING_ORDER_URL_W_PARAMS, { accountNumber, includeCanceled: true }),
    'offerOrders',
    { accountNumber },
  )();
  return actionCreator(dispatch, getState);
};


export const cancelOrder = (accountNumber, orderId, orderType) => async (dispatch, getState) => {
  const { authToken } = getState();
  const url = replacePlaceholders(
    `${API_OFFERING_ORDER_URL}/{orderId}`,
    { accountNumber, orderId },
  );
  dispatch({ type: ORDER_CANCELED, orderType, id: orderId });
  await callWebApi('DELETE', url, {}, authToken);
};



// WEBPACK FOOTER //
// ./src/actions/investment.js